<script setup lang="ts">
import {onMounted} from 'vue';
import {RouterView} from 'vue-router';
import {BarChart3, Building2, ChartLine, FileText, LayoutGrid, Settings, Tags, Trophy, Users, Wrench} from 'lucide-vue-next';
import AppShell from '@/views/shell/AppShell.vue';
import {type NavItem} from '@/views/shell/navItems.js';
import {reload} from '@/base/loadingState.js';

const ITEMS: NavItem[] = [
    {label: 'Gebruikers', to: '/admin/user', icon: Users},
    {label: "Thema's", to: '/admin/thema', icon: Tags},
    {label: 'Instellingen', to: '/admin/organization', icon: Building2},
    {label: 'Mijlpalen', to: '/admin/milestone', icon: Trophy},
    {label: "KPI's", to: '/admin/kpi', icon: ChartLine},
    {label: 'Rapporten', to: '/admin/status', icon: FileText},
    {label: 'AltView', to: '/admin/altview', icon: LayoutGrid},
    {label: 'Vecozo', to: '/admin/vecozo', icon: Settings},
    {label: 'Dashboard', to: '/admin/dashboard', icon: BarChart3, exact: false},
    {label: 'Beheer', to: '/admin/admin', icon: Wrench},
];

onMounted(async () => {
    await reload();
});
</script>

<template>
    <AppShell landing="Admin" :items="ITEMS">
        <RouterView/>
    </AppShell>
</template>
